import type { Translations } from '../types';

export const en: Translations = {
  common: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    cart: 'Cart',
    wishlist: 'Wishlist',
    profile: 'My Account',
    login: 'Login',
    logout: 'Logout',
    search: 'Search',
    menu: 'Menu',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    viewAll: 'View All',
    readMore: 'Read More',
    learnMore: 'Learn More',
    giftCard: 'Gift Card',
    customerService: 'Customer Service',
    faq: 'FAQ',
    sizeGuide: 'Size Guide',
    tradeIn: 'Alice Trade In',
    trackOrder: 'Track Order',
    categories: 'Categories',
  },
  product: {
    addToCart: 'Add to Cart',
    addedToCart: 'Added to Cart',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    price: 'Price',
    quantity: 'Quantity',
    size: 'Size',
    color: 'Color',
    description: 'Description',
    details: 'Details',
    reviews: 'Reviews',
    relatedProducts: 'Related Products',
    noProductsFound: 'No products found',
    selectOption: 'Select option',
    selectSize: 'Select size',
    selectColor: 'Select color',
  },
  cart: {
    title: 'Shopping Cart',
    empty: 'Your cart is empty',
    itemsInCart: 'items in cart',
    subtotal: 'Subtotal',
    total: 'Total',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    removeItem: 'Remove item',
    updateQuantity: 'Update quantity',
    proceedToCheckout: 'Proceed to Checkout',
  },
  auth: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signOut: 'Sign Out',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    welcomeBack: 'Welcome back',
    personalArea: 'My Account',
  },
  footer: {
    about: 'About',
    shipping: 'Shipping',
    returns: 'Returns',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    accessibility: 'Accessibility',
    cookies: 'Cookie Settings',
    contactUs: 'Contact Us',
    followUs: 'Follow Us',
    newsletter: 'Subscribe to our newsletter',
    newsletterPlaceholder: 'Enter your email',
    subscribe: 'Subscribe',
    subscribed: 'Successfully subscribed!',
    importantLinks: 'Important Links',
    copyright: '© All rights reserved',
  },
  newsletter: {
    title: 'Stay Updated',
    subtitle: 'Subscribe to our newsletter for updates on promotions and deals',
    placeholder: 'Email address',
    button: 'Subscribe',
    success: 'Successfully subscribed to the newsletter!',
    error: 'An error occurred, please try again',
    consent: 'I agree to receive updates and promotions',
  },
  cookies: {
    bannerTitle: 'We use cookies',
    bannerText: 'This website uses cookies to enhance your browsing experience.',
    accept: 'Accept All',
    reject: 'Reject All',
    customize: 'Customize',
    preferencesTitle: 'Cookie Preferences',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'These cookies are essential for the website to function and cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how visitors use the website.',
    marketing: 'Marketing Cookies',
    marketingDesc: 'Used to display relevant ads to you.',
    savePreferences: 'Save Preferences',
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
    notFound: 'Page not found',
    unauthorized: 'You are not authorized to view this content',
    networkError: 'Network error. Please check your internet connection.',
    tryAgain: 'Try Again',
  },
  seo: {
    defaultTitle: 'Alice Jewellery - Jewelry & Watches',
    defaultDescription: 'The best jewelry and watch store in Israel. Wide range of gold jewelry, diamonds, and watches.',
  },
};
